import React, { useState } from "react";
import { Card } from "@material-tailwind/react";
import toast from "react-hot-toast";

export default function EducationDetailsPopUp({
  closeModal,
  handleAddEducationDetails,
  degree,
  major,
  institution,
  grade,
  start_year,
  end_year,
  details,
}) {
  const [formData, setFormData] = useState({
    degree: degree || "",
    major: major || "",
    institution: institution || "",
    grade: grade || "",
    start_year: start_year || "",
    end_year: end_year || "",
    details: details || "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (
      !formData.degree ||
      !formData.major ||
      !formData.institution ||
      !formData.start_year ||
      !formData.end_year
    ) {
      toast.error("Please fill in all required fields");
      return;
    }

    if (parseInt(formData.start_year) > parseInt(formData.end_year)) {
      toast.error("Start year cannot be after end year");
      return;
    }

    await handleAddEducationDetails(formData);
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-80 z-50">
      <Card
        color="transparent"
        shadow={false}
        className="w-[90%] max-w-[700px] max-h-[90vh] bg-gray-900 rounded-[20px] overflow-hidden flex flex-col"
      >
        <div className="overflow-y-auto flex-1 p-6">
          <form
            onSubmit={handleSubmit}
            className="text-white flex flex-col space-y-6"
          >
            {/* Degree */}
            <div className="relative z-0 w-full group">
              <label htmlFor="degree" className="block text-sm">
                Degree <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="degree"
                className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
                onChange={handleChange}
                value={formData.degree}
              />
              <p className="text-xs text-red-400 mt-1">
                Note: List your degree (e.g., Bachelor of Technology, Master of
                Science)
              </p>
            </div>

            {/* Major */}
            <div className="relative z-0 w-full group">
              <label htmlFor="major" className="block text-sm">
                Major <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="major"
                className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
                onChange={handleChange}
                value={formData.major}
              />
              <p className="text-xs text-red-400 mt-1">
                Note: Your field of study (e.g., Computer Science, Electrical
                Engineering)
              </p>
            </div>

            {/* Institution */}
            <div className="relative z-0 w-full group">
              <label htmlFor="institution" className="block text-sm">
                Institution <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="institution"
                className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
                onChange={handleChange}
                value={formData.institution}
              />
            </div>

            {/* Grade */}
            <div className="relative z-0 w-full group">
              <label htmlFor="grade" className="block text-sm">
                Grade
              </label>
              <input
                type="text"
                name="grade"
                className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                onChange={handleChange}
                value={formData.grade}
              />
              <p className="text-xs text-red-400 mt-1">
                Note: Your final grade (e.g., 8.5 CGPA, First Class with
                Distinction)
              </p>
            </div>

            {/* Years */}
            <div className="grid grid-cols-2 gap-4">
              {/* Start Year */}
              <div className="relative z-0 w-full group">
                <label htmlFor="start_year" className="block text-sm">
                  Start Year <span className="text-red-500">*</span>
                </label>
                <input
                  type="number"
                  name="start_year"
                  min="1900"
                  max={new Date().getFullYear()}
                  className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                  onChange={handleChange}
                  value={formData.start_year}
                />
              </div>

              {/* End Year */}
              <div className="relative z-0 w-full group">
                <label htmlFor="end_year" className="block text-sm">
                  End Year <span className="text-red-500">*</span>
                </label>
                <input
                  type="number"
                  name="end_year"
                  min="1900"
                  max={new Date().getFullYear()}
                  className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                  onChange={handleChange}
                  value={formData.end_year}
                />
              </div>
            </div>

            {/* Additional Details */}
            <div className="relative z-0 w-full group">
              <label htmlFor="details" className="block text-sm">
                Additional Details
              </label>
              <textarea
                name="details"
                rows="3"
                className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                onChange={handleChange}
                value={formData.details}
              />
              <p className="text-xs text-red-400 mt-1">
                Note: Any additional information about your education
              </p>
            </div>

            <p className="text-sm text-gray-400">
              <span className="text-red-500">*</span> compulsory fields
            </p>

            <div className="flex items-center justify-between mt-5 space-x-4">
              <button
                type="submit"
                className="w-full px-6 py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
              >
                Save
              </button>
              <button
                type="button"
                onClick={closeModal}
                className="w-full px-6 py-3 bg-gray-500 text-white rounded-lg hover:bg-gray-600"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </Card>
    </div>
  );
}
